import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { ExclusionItemGridDataProviderFactory } from '../factory/ExclusionItemGridDataProviderFactory';
import { ExclusionItemGridBaseDataProvider } from '../dataProvider/ExclusionItemGridBaseDataProvider';
export class ExclusionItemGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: ExclusionItemGridDataProviderFactory;
  public dataProvider: ExclusionItemGridBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new ExclusionItemGridDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<any> {
    return this.dataProvider.getDataForView();
  }
}
